import React, { useState } from 'react';
import {
  Button,
  Form,
  Input,
  Modal,
  message,
  Typography,
  Space,
  Descriptions,
  Card,
} from 'antd';
import { AlertOutlined } from '@ant-design/icons';
import { fetchAPI } from '../../../utils/api';
import { OrderV2 } from './types';

const { Text } = Typography;

interface Props {
  record: OrderV2;
  onSuccess?: () => void;
  onOpenChange?: (open: boolean) => void;
}

const OrderEscalationModal: React.FC<Props> = ({
  record,
  onSuccess,
  onOpenChange,
}) => {
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const onFinish = async (values: any) => {
    setLoading(true);
    try {
      await fetchAPI('order/peter/escalate', {
        method: 'POST',
        version: '1.0',
        payload: {
          order_id: record.id,
          reason: values.reason,
        },
      });
      message.success('Escalation email sent to Peter!');
      setVisible(false);
      form.resetFields();
      if (onSuccess) onSuccess();
    } catch (error) {
      message.error('Failed to send escalation email');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button
        type="default"
        icon={<AlertOutlined style={{ color: '#faad14' }} />}
        onClick={e => {
          e.stopPropagation();
          setVisible(true);
          onOpenChange?.(true);
        }}
        title="Escalate to Peter"
      >
        Escalate
      </Button>
      <Modal
        title="Escalate Order to Peter"
        visible={visible}
        onCancel={() => {
          setVisible(false);
          form.resetFields();
        }}
        onOk={() => form.submit()}
        confirmLoading={loading}
        width={600}
        destroyOnClose
      >
        <Space direction="vertical" style={{ width: '100%' }} size="large">
          <Card size="small" title="Order Details">
            <Descriptions column={2} size="small">
              <Descriptions.Item label="SAID">{record.id}</Descriptions.Item>
              <Descriptions.Item label="Buyer">
                {record.buyer_name}
              </Descriptions.Item>
              <Descriptions.Item label="PO Ref">
                {record.po_reference_number}
              </Descriptions.Item>
              <Descriptions.Item label="Total">
                {record.total_price_all} {record.currency}
              </Descriptions.Item>
            </Descriptions>
          </Card>

          <Form form={form} layout="vertical" onFinish={onFinish}>
            <Form.Item
              name="reason"
              label="Reason for Escalation"
              rules={[{ required: true, message: 'Please input your reason' }]}
            >
              <Input.TextArea
                rows={4}
                placeholder="Type your escalation reason here..."
              />
            </Form.Item>
          </Form>

          <Typography.Paragraph type="secondary" style={{ fontSize: '12px' }}>
            This will send a detailed email to{' '}
            <Text strong>peter@sourcesage.co</Text> including the order details
            and its line items for further review.
          </Typography.Paragraph>
        </Space>
      </Modal>
    </>
  );
};

export default OrderEscalationModal;
